import React, { FC } from 'react'
import ConfirmationModal from 'shared/components/confirmation-modal'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'

interface ItemDeleteModalProps {
  onDelete: () => void
  opened: boolean
  onClose: (value: boolean) => void
}

export const ItemDeleteModal: FC<ItemDeleteModalProps> = ({ onDelete, onClose, opened }) => {
  const { t } = useLocoTranslation()
  return (
    <ConfirmationModal
      confirmationText={t('dashboard.store.item.delete_confirmation')}
      toastCaption={t('dashboard.store.item.delete_success')}
      opened={opened}
      onClose={() => onClose(false)}
      onConfirm={onDelete}
    />
  )
}
